export const rewardTypeFormValidation = (rewardTypeDetails: any) => {
  let errors: Record<string, string> = {};
  if (!rewardTypeDetails?.name.trim()) {
    errors["name"] = "Reward Name is required";
  }
  let status = Object.keys(errors).length > 0;
  return { status, errors };
};
